import { Box } from '@mui/material';
import { BreadCrumbs as BreadCrumbsComponent } from '@leapeasy/ui-kit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { primaryMenu, secondaryMenu } from 'data/ui/menu';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openDetails } from 'store/actions/uiActions';
import { useBreadcrumbTrail } from 'hooks/useBreadcrumbTrail';
import { readStoredUser } from 'utils/authSession';
import { resolveMenuItemLink } from 'utils/menuAccess';

const getMenuItems = (menuKey, role) => {
  const parentMenu = menuKey.includes('.') ? menuKey.slice(0, menuKey.indexOf('.')) : null;

  const parentItem =
    primaryMenu.find((menu) => menu.key === (parentMenu || menuKey)) ||
    secondaryMenu.find((menu) => menu.key === (parentMenu || menuKey));

  if (!parentItem) return [];

  if (parentItem.key === menuKey || !parentItem.child) {
    return [parentItem];
  }

  const childItem = parentItem.child.find((child) => `${parentItem.key}.${child.key}` === menuKey);
  return childItem
    ? [
        { ...parentItem, icon: null },
        { ...childItem, link: resolveMenuItemLink(role, childItem) },
      ]
    : [parentItem];
};

export const BreadCrumbs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeMenu = useSelector((state) => state.getIn(['ui', 'menuItem'])) || 'dashboard';

  const role = readStoredUser()?.role;
  const menuItems = useMemo(() => getMenuItems(activeMenu, role), [activeMenu, role]);
  const { items, currentItem, hidden } = useBreadcrumbTrail(menuItems);

  const onClickItem = (item) => {
    if (!item?.link) return;
    if (item.name === currentItem) return;

    dispatch(openDetails(null));
    navigate(item.link, item.state ? { state: item.state } : undefined);
  };

  if (hidden || !items.length) {
    return null;
  }

  return (
    <Box sx={{ py: 1, px: 3 }}>
      <BreadCrumbsComponent items={items} currentItem={currentItem} onClickItem={onClickItem} />
    </Box>
  );
};
